import { useTranslation } from 'react-i18next';

import Modal from '@/components/ui/modal';

interface VersionWarningModalProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  version: string;
  onConfirm: () => void;
}

const VersionWarningModal = ({
  isOpen,
  onOpenChange,
  version,
  onConfirm,
}: VersionWarningModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      open={isOpen}
      onOpenChange={onOpenChange}
      title={t('release_note.modal.add.header', { version })}
      acceptButtonLabel={t('actions.save_anyway')}
      acceptButtonVariant="destructive"
      onConfirm={onConfirm}
    >
      <p>{t('release_note.modal.add.description')}</p>
    </Modal>
  );
};

export default VersionWarningModal;
